<template>
  <div class="ws-line"></div>
</template>

<script>
export default {};
</script>